import { getAuthAxiosBackend } from "../../helpers/axios"

class InjuryServices{

    get(id){
        return getAuthAxiosBackend().get('government-loans/woundeds/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('government-loans/woundeds', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('government-loans/woundeds/' + id)
    }
}

export default new InjuryServices()